import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackSearchAnalysesWidgetsEvents = createAnalyticsTracker(
  'searchAnalysesWidgets',
);
